import categoryApi from "api/CategoryApi";
import {
  FETCH_DETAIL_CATEGORY_SUCCESS,
  FETCH_LIST_CATEGORY_SUCCESS,
} from "redux/ActionTypes/CategoryActionTypes";
import { activeProgress, disableProgress } from "./ProgressActionCreators";
import ToastCustom from "shared/components/ToastCustom";
import { FETCH_DELETE_DETAIL_CATEGORY_SUCCESS } from "../ActionTypes/CategoryActionTypes";

export const fetchListCategoryRequest = () => {
  return (dispatch) => {
    dispatch(activeProgress());
    return categoryApi
      .getAll()
      .then(
        (res) => {
          dispatch(fetchListCategorySuccess(res.body));
        },
        (err) => {}
      )
      .finally(() => {
        dispatch(disableProgress());
      });
  };
};

export const fetchDeleteCategoryRequest = (id) => {
  return (dispatch) => {
    dispatch(activeProgress());
    return categoryApi
      .delete(id)
      .then(
        (res) => {
          ToastCustom.success("Xóa Thành Công");
        },
        (err) => {
          console.log(err);
          ToastCustom.error("Xóa Thất bại");
        }
      )
      .finally(() => {
        dispatch(disableProgress());
      });
  };
};

export const fetchCreateCategoryRequest = (data) => {
  return (dispatch) => {
    dispatch(activeProgress());
    return categoryApi
      .create(data)
      .then(
        (res) => {
          ToastCustom.success("Thêm Thành Công");
        },
        (err) => {
          console.log(err);
          ToastCustom.error("Thêm Thất bại");
        }
      )
      .finally(() => {
        dispatch(disableProgress());
      });
  };
};

export const fetchDetailCategoryRequest = (id) => {
  return (dispatch) => {
    dispatch(activeProgress());
    return categoryApi
      .getById(id)
      .then(
        (res) => {
          dispatch(fetchDetailCategorySuccess(res.body));
        },
        (err) => {}
      )
      .finally(() => {
        dispatch(disableProgress());
      });
  };
};

export const fetchDeleteDetailCategoryRequest = () => {
  return (dispatch) => {
    dispatch(fetchDeleteDetailCategorySuccess());
  };
};

export const fetchListCategorySuccess = (data) => {
  return {
    type: FETCH_LIST_CATEGORY_SUCCESS,
    payload: data,
  };
};

export const fetchDetailCategorySuccess = (data) => {
  return {
    type: FETCH_DETAIL_CATEGORY_SUCCESS,
    payload: data,
  };
};

export const fetchDeleteDetailCategorySuccess = () => {
  return {
    type: FETCH_DELETE_DETAIL_CATEGORY_SUCCESS,
  };
};
